const TIME_VALUE_PATTERN = /^(\d{1,2}):(\d{2})$/

export type ParsedTimeValue = {
  hours: number
  minutes: number
}

export const parseTimeValue = (value: string): ParsedTimeValue | null => {
  const trimmedValue = value.trim()
  if (!trimmedValue) {
    return null
  }

  const match = TIME_VALUE_PATTERN.exec(trimmedValue)
  if (!match) {
    return null
  }

  const hours = Number(match[1])
  const minutes = Number(match[2])

  if (
    !Number.isInteger(hours) ||
    !Number.isInteger(minutes) ||
    hours < 0 ||
    hours > 23 ||
    minutes < 0 ||
    minutes > 59
  ) {
    return null
  }

  return { hours, minutes }
}

export const isValidTimeValue = (value: string) => parseTimeValue(value) !== null

export const formatTimeValue = (hours: number, minutes: number) =>
  `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`

export const normalizeTimeValue = (value: string) => {
  const parsedValue = parseTimeValue(value)
  return parsedValue ? formatTimeValue(parsedValue.hours, parsedValue.minutes) : value.trim()
}

export const buildUtcDatePreservingClock = (birthDate: string, birthTime: string) => {
  if (!birthDate) {
    return null
  }

  const parsedTime = parseTimeValue(birthTime)
  if (!parsedTime) {
    return null
  }

  const [year, month, day] = birthDate.split('-').map(Number)
  if (![year, month, day].every(Number.isInteger)) {
    return null
  }

  const date = new Date(Date.UTC(year, month - 1, day, parsedTime.hours, parsedTime.minutes, 0))
  if (
    Number.isNaN(date.getTime()) ||
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return null
  }

  return date
}
